@if (canAdd) {
    <div class="flex justify-center pt-2">
        <button (click)="onAddFriendClicked()" class="text-sm justify-center w-full flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="isProcessing">
            @if (!isProcessing) {
                Add Friend
            } @else {
                <busy-spin></busy-spin>
            }
        </button>
    </div>
} @else if (isPending) {
    <a href="{{ friendUrl }}" class="flex flex-row gap-1 items-center rounded shadow-sm text-faded-80 text-xs sm:text-sm pl-1 pr-1 pb-[2px] pt-[2px] bg-green-700 bg-opacity-80">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="friendSvgIcon" />
        </svg>
        <div>
            Pending Request
        </div>
    </a>
} @else if (isFriend) {
    <div class="flex flex-row gap-1 items-center rounded shadow-sm text-white text-xs sm:text-sm pl-1 pr-1 pb-[2px] pt-[2px] bg-green-700 cursor-default">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="friendSvgIcon" />
        </svg>
        <div>
            Friend
        </div>
    </div>
}